import React from 'react';

interface NotificationTypesSidebarProps {
  selectedType: string;
  onTypeSelect: (type: string) => void;
}

export const NotificationTypesSidebar: React.FC<NotificationTypesSidebarProps> = ({ selectedType, onTypeSelect }) => {
  return (
    <div className='col-span-3'>
      <div className='bg-white py-4 border border-[#E5E7EB] rounded-tl-[10px] rounded-bl-[10px] h-full'>
        <div className='px-6 pt-4 pb-1'>
          <h2 className='text-base font-semibold text-cxcentral-green mb-3'>Notification Types</h2>
        </div>
        <div className='gap-1.5 flex flex-col'>
          <div
            onClick={() => onTypeSelect('banner')}
            className={`cursor-pointer font-medium transition-colors px-6 py-4 text-[#667085] font-semibold text-[15px] ${
              selectedType === 'banner' ? 'bg-[#D5EEEE]' : 'bg-transparent'
            }`}
          >
            Banner
          </div>
        </div>
      </div>
    </div>
  );
};
